

import { useEffect } from "react"
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateYukData } from "../../../../../features/updateLoad/updateLoadSlice"
import { useSelector } from "react-redux"

const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YukunTuruInput = ({data, name, isRequired, labelText="Yükün Türü"}) => {

    const [text, setText] = useState(data.yukTuru)
    const dispatch =  useDispatch()
    const {showErrors, showRequiredPlaces} = useSelector(state => state.updateLoad)
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        setText(data.yukTuru)
    },[data.yukTuru])
    
    const handleChange = (e) => {
        setText(e.target.value)
        dispatch(updateYukData({yukTuru: e.target.value}))
    }

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && !data.yukTuru && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.yukTuru, showRequiredPlaces, showErrors])

  return (
    <Container value={text} radius={"5px"} isError={isError}>
        <input type="text" id={"text"} onChange={handleChange} value={text} name={name}/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
    </Container>
  )
}

export default YukunTuruInput